import { COUNTRY } from './enums';

export const USA_COUNTRY_OPTION = { id: '1', name: COUNTRY.USA };

export const navigationHeight = 51;

export const MSA_AGREEMENT_LINK =
  'https://resurety.com/master-subscription-agreement';

/**
 * Maximum fixed price the offer and bid forms accept. The forms apply it to every product
 * type; the backend applies it to $/MWh prices only. See the bid-price wiki page.
 */
export const MAX_FIXED_PRICE = 1000;

/**
 * Post-COD Credit Support on a bid or an offer must be less than this. Their `DECIMAL(10,2)`
 * column holds at most 99,999,999.99, matching the `@Digits` on their request DTOs.
 */
export const CREDIT_SUPPORT_LIMIT = 100_000_000;

/**
 * Buyer and Seller Credit on a proposal must be less than this. The negotiation and proposal
 * columns are `DECIMAL(18,6)`; the form rounds to cents, so it accepts at most 999,999,999,999.99.
 */
export const PROPOSAL_CREDIT_SUPPORT_LIMIT = 1_000_000_000_000;

/** External link to the platform fee schedule document. */
export const FEE_SCHEDULE_URL =
  'https://resurety.com/?resurety-regulatory-document=335';
